const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://reportfius-backend.up.railway.app'
    : 'http://localhost:3001');

export const buildAttachmentUrl = (fileReference) => {
  if (!fileReference) {
    return null;
  }

  const normalizedRef = String(fileReference).trim();
  if (!normalizedRef) {
    return null;
  }

  if (/^https?:\/\//i.test(normalizedRef)) {
    return normalizedRef;
  }

  if (normalizedRef.startsWith('/api/uploads/')) {
    return `${API_BASE_URL}${normalizedRef}`;
  }

  return `${API_BASE_URL}/api/complaints/attachment?ref=${encodeURIComponent(normalizedRef)}`;
};
